import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { ErrorProps } from '../../interfaces/errorInterface';

const Error: React.FC<ErrorProps> = ({ message }) => {
	return (
		<div style={{ width: '100%' }}>
			<Alert severity="error">
				<AlertTitle>Erreur</AlertTitle>
				{message}
			</Alert>
		</div>
	);
};

export default Error;
